import {FC} from 'react';
import styles from './index.less';

interface IconProps {
    textValue: string;
    fontColor?: string;
    bgColor?: string;
    width?: string;
    height?: string;
    borderColor?: string;
}

const Icon: FC<IconProps> = ({
    textValue,
    fontColor,
    bgColor,
    width,
    height,
    borderColor,
}) => {

    return (
        <div
            className={styles.container}
            style={{
                color: fontColor,
                backgroundColor: bgColor,
                width: width,
                height: height,
                borderColor: borderColor,
            }}
        >
            {textValue}
        </div>
    );
};

export default Icon;
